
import * as cacheManager from "./cache"
import * as dataPreparer from "./data"

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/';
const spaces = new RegExp('( |(%20))+', 'g');

const OBJECT_EXP = 1000 * 60 * 60 * 18; // 18 hours

// Return an instructor object (dict)
async function getInstructor(eidHash) {
    let cacheKey = ['getInstructor', eidHash];
    let instructor = cacheManager.getCache(cacheKey);
    if (instructor) return instructor;
    try {
        let res = await fetch(apiUrl + 'instructor/' + eidHash + '/');
        if (await res.status !== 200) return null;
        return cacheManager.setCache(cacheKey, (await res.json()).data.instructor, OBJECT_EXP); // TODO: process the data first (?)
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}

// Return a course object (dict)
async function getCourse(courseId) {
    let cacheKey = ['getCourse', courseId];
    let course = cacheManager.getCache(cacheKey);
    if (course) return course;
    try {
        let res = await fetch(apiUrl + 'course/' + courseId + '/');
        if (await res.status !== 200) return null;
        let course = (await res.json()).data.course;
        course.instructors = dataPreparer.aggregateSectionData(await course.sections);
        // delete await course.sections;
        return cacheManager.setCache(cacheKey, await course, OBJECT_EXP);
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}

// Return a query result set in the form of
// {'data': (results), 'page_count': (int), 'has_next': (boolean)}
async function searchCourses(query, pageNum=1) {
    // inspect local storage (cache) first
    query = query.trim().replace(spaces, '+').toLowerCase();
    let cacheKey = ['searchCourses', query, pageNum];
    let results = cacheManager.getCache(cacheKey);
    if (results) return results;
    try {
        let res = await fetch(apiUrl + 'course/search/' + query + '/' + pageNum + '/');
        if (await res.status !== 200) return null;
        return cacheManager.setCache(cacheKey, await res.json());
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}

// Return a query result set (same as above form)
async function searchInstructors(query, pageNum=1) {
    // inspect local storage (cache) first
    query = query.trim().replace(spaces, '+').toLowerCase();
    let cacheKey = ['searchInstructors', query, pageNum];
    let results = cacheManager.getCache(cacheKey);
    if (results) return results;
    try {
        let res = await fetch(apiUrl + 'instructor/search/' + query + '/' + pageNum + '/');
        if (await res.status !== 200) return null;
        return cacheManager.setCache(cacheKey, await res.json());
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}

// Return a query result set (same as above form)
async function getDepartment(deptNum, type, pageNum=1) {
    let cacheKey = ['getDepartment', deptNum, type, pageNum];
    let results = cacheManager.getCache(cacheKey);
    if (results) return results;
    try {
        let res = await fetch(apiUrl + 'department/' + deptNum + '/' + type + '/' + pageNum + '/');
        return cacheManager.setCache(cacheKey, res.json());
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}

async function getDepartmentCourses(deptNum, pageNum=1) {
    return getDepartment(deptNum, 'courses', pageNum);
}

async function getDepartmentInstructors(deptNum, pageNum=1) {
    return getDepartment(deptNum, 'instructors', pageNum);
}

// Return a list of department objects (dict)
let _DEPARTMENTS;
async function getAllDepartments() {
    let cacheKey = 'getAllDepartments';
    let departments = cacheManager.getActiveCache(cacheKey);
    if (departments && departments.lastUpdated) return departments;
    try {
        if (_DEPARTMENTS) return _DEPARTMENTS;
        let res = await fetch(apiUrl + 'department/list/');
        _DEPARTMENTS = cacheManager.setActiveCache(cacheKey,
            dataPreparer.createDepartmentTable((await res.json()).data));
        return _DEPARTMENTS;
    } catch (err) {
        console.error(err); // TODO: change this to debug only
    }
}


export { getDepartmentCourses, getDepartmentInstructors, getAllDepartments, searchCourses, searchInstructors,
    getCourse, getInstructor };


// WEBPACK FOOTER //
// ./src/common/api.js